import React, { useState, useEffect } from "react";
import { Form, Select, InputNumber, Input, Typography } from "antd";
import { useTranslation } from "react-i18next";
import axios from "axios";
import { elvis } from "../../Utils";

const { Option } = Select;
const { Title } = Typography;

const StoredForm = props => {
  const [subtypes, setSubtypes] = useState([]);
  const { t } = useTranslation();
  const [form] = Form.useForm();
  const isEditMode = props.isEditMode || false;

  const formItemLayout = {
    labelCol: {
      sm: { span: 8 }
    },
    wrapperCol: {
      sm: { span: 16 }
    }
  };

  // Load types from API
  useEffect(() => {
    axios
      .get(process.env.REACT_APP_API_ENDPOINT + "/farm/enums/agriculture-product-subtypes")
      .then(({ data }) => {
        setSubtypes(data);
      })
      .catch(function (error) {
        console.log(error);
      });
  }, []);

  // Initialize form with record data
  useEffect(() => {
    if (props.record.asset) {
      form.setFieldsValue({
        agricultureProductSubtype: props.record.asset.agricultureProductSubtype,
        gatePrice: props.record.asset.gatePrice,
        averageInvested: props.record.asset.averageInvested,
        expectedYield: props.record.asset.expectedYield,
        yearProduction: props.record.asset.yearProduction,
        totalStored: props.record.asset.totalStored,
      });
    }
  }, [props.record.asset, form]);

  // Reset form when exiting edit mode
  useEffect(() => {
    if (!isEditMode && props.record.asset) {
      form.resetFields();
      form.setFieldsValue({
        agricultureProductSubtype: props.record.asset.agricultureProductSubtype,
        gatePrice: props.record.asset.gatePrice,
        averageInvested: props.record.asset.averageInvested,
        expectedYield: props.record.asset.expectedYield,
        yearProduction: props.record.asset.yearProduction,
        totalStored: props.record.asset.totalStored,
      });
    }
  }, [isEditMode, form, props.record.asset]);

  // Handle form changes and notify parent
  const handleFormChange = () => {
    if (!isEditMode) return;

    const values = form.getFieldsValue();
    const errors = form.getFieldsError();
    const isValid = errors.every(error => !error.errors.length);

    const newAsset = { ...props.record };
    newAsset.asset.gatePrice = elvis(values.gatePrice);
    newAsset.asset.averageInvested = elvis(values.averageInvested);
    newAsset.asset.expectedYield = elvis(values.expectedYield);
    newAsset.asset.yearProduction = elvis(values.yearProduction);
    newAsset.asset.totalStored = elvis(values.totalStored);
    newAsset.asset.agricultureProductSubtype = elvis(values.agricultureProductSubtype);
    newAsset.valid = isValid;
    props.parentCallback(newAsset);
  };

  return (
    <Form
      form={form}
      {...formItemLayout}
      className="details_form"
      onValuesChange={handleFormChange}
      onFieldsChange={handleFormChange}
    >
      <Title
        className="details_form_header"
        title="Asset details"
        subTitle="Stored Products"
      />
      <Form.Item
        label="Year production (kg)"
        name="yearProduction"
        rules={isEditMode ? [{ required: false }] : []}
      >
        <InputNumber disabled={!isEditMode} />
      </Form.Item>
      <Form.Item
        label="Expected yield (€)"
        name="expectedYield"
        rules={isEditMode ? [{ required: false }] : []}
      >
        <Input disabled={!isEditMode} />
      </Form.Item>
      <Form.Item
        label="Average invested (€)"
        name="averageInvested"
        rules={isEditMode ? [{ required: false }] : []}
      >
        <Input disabled={!isEditMode} />
      </Form.Item>
      <Form.Item
        label="Pre-disaster value (€)"
        name="gatePrice"
        rules={isEditMode ? [{ required: false }] : []}
      >
        <InputNumber disabled={!isEditMode} />
      </Form.Item>
      <Form.Item
        label="Total stored (kg)"
        name="totalStored"
        rules={isEditMode ? [{ required: false }] : []}
      >
        <InputNumber disabled={!isEditMode} />
      </Form.Item>
      <Form.Item
        label="Subtype"
        name="agricultureProductSubtype"
        rules={isEditMode ? [{ required: false }] : []}
      >
        <Select disabled={!isEditMode}>
          {subtypes.map(name => (
            <Option key={name} value={name}>
              {t("farmEnums.agriculture_product_subtype." + name, name)}
            </Option>
          ))}
        </Select>
      </Form.Item>
    </Form>
  );
};

export default StoredForm;